import $ from "jquery"
import messageResource from "../messageResource"
import TemplateView from "../TemplateView";
import {PaperOrientation, PaperSize} from "../pdf/constants";
import ListSelector from "../controls/ListSelector";

export default class PDFSettingsPreview extends TemplateView {
    constructor($containerEl, lightboxId) {
        super($containerEl);
        this.lightboxId = lightboxId;
    }

    templateHtml() {
        return "<div class='pdfPreviewModeElement pdfPreviewInnerContent'>" +
               "  <table cellpadding='0' cellspacing='0'>" +
               "    <tr>" +
               "      <td class='pdfParametersSectionTd'>" +
               "        <div id='<%=id%>_pdfParametersSection' class='pdfParametersSection'>" +
               "          <div class='pageSetupSection'>" +
               "            <div class='parametersSectionHeader'><%=pageSetupLabel%></div>" +
               "            <div>" +
               "              <div class='selectorLabel'><%=paperSizeLabel%></div>" +
               "              <div class='selectorContainer paperSizeSelectorCt' id='<%=id%>_paperSizeSelector'></div>" +
               "            </div>" +
               "            <div class='pageOrientationSelector'>" +
               "              <div class='selectorLabel'><%=orientationLabel%></div>" +
               "              <div class='selectorContainer paperOrientationSelectorCt'>" +
               "                <table>" +
               "                  <tr>" +
               "                    <td><input type='radio' name='<%=id%>_pageOrientation' id='<%=id%>_portrait'/></td>" +
               "                    <td><label for='<%=id%>_portrait'><%=orientationPortraitLabel%></label></td>" +
               "                  </tr>" +
               "                  <tr>" +
               "                    <td><input type='radio' name='<%=id%>_pageOrientation' id='<%=id%>_landscape'/></td>" +
               "                    <td><label for='<%=id%>_landscape'><%=orientationLandscapeLabel%></label></td>" +
               "                  </tr>" +
               "                </table>" +
               "              </div>" +
               "            </div>" +
               "            <div class='showHeaderOnEachPage'>" +
               "              <table>" +
               "                <tr>" +
               "                  <td><input type='checkbox' id='<%=id%>_headerOnEachPage'/></td>" +
               "                  <td><label for='<%=id%>_headerOnEachPage'><%=showHeaderLabel%></label></td>" +
               "                </tr>" +
               "              </table>" +
               "            </div>" +
               "            <div class='showLogoInHeader'>" +
               "              <table>" +
               "                <tr>" +
               "                  <td><input type='checkbox' id='<%=id%>_logoInHeader'/></td>" +
               "                  <td><label for='<%=id%>_logoInHeader'><%=showLogoLabel%></label></td>" +
               "                </tr>" +
               "              </table>" +
               "            </div>" +
               "          </div>" +
               "          <div class='delimiter'></div>" +
               "          <div class='customSettingsSectionContainer'></div>" +
               "          <div class='bottomSection'>" +
               "            <div class='delimiter'></div>" +
               "            <span id='<%=id%>_numberOfPages' class='numberOfPages'>" +
               "              <%=pagesNumberLabel%>" +
               "              <span id='<%=id%>_numberOfPagesContainer'></span>" +
               "            </span>" +
               "            <div id='<%=id%>_updatePreviewBtn' class='updatePreviewButton disabled'><%=updatePreviewButtonLabel%></div>" +
               "          </div>" +
               "        </div>" +
               "      </td>" +
               "      <td class='pdfPreviewTd'>" +
               "        <div id='pdfPreviewSectionId' class='pdfPreviewSection'></div>" +
               "        <div id='pdfPreviewSectionMoireId' class='pdfPreviewSectionMoire'>" +
               "          <div class='centeredContent'>" +
               "            <div class='previewSpinnerPlaceholder' id='previewChartPDFSpinner'></div>" +
               "            <div class='previewLoadingMessage'><%=loadingPreviewLabel%></div>" +
               "          </div>" +
               "        </div>" +
               "      </td>" +
               "    </tr>" +
               "  </table>" +
               "</div>"
    }

    afterRender() {
        var self = this;

        this.parametersChanged = false;
        this.changesCallback = function() {
            self.handleParameterChange();
        };

        this.section = $(document.getElementById(this.lightboxId + "_pdfParametersSection"));

        this.initPaperSizeSelector();
        this.initPaperOrientationRadio();
        this.initHeaderCheckboxes();

        this.numberOfPagesContainer = $(document.getElementById(this.lightboxId + "_numberOfPagesContainer"));

        this.updatePreviewButton = $(document.getElementById(this.lightboxId + "_updatePreviewBtn"));
        this.updatePreviewButton.off();
        this.updatePreviewButton.hover(
            function() { $(this).addClass("hovered"); },
            function() { $(this).removeClass("hovered"); }
        );
        this.updatePreviewButton.click(function() { self.onUpdatePreviewButtonClicked() });

        this.subscribeToEvents();
    }

    update() {
        var printParameters = this.getStore().getPrintParametersForSave();

        this.paperSizeSelectorContainer.innerHTML = "";
        this.paperSizeSelector = new ListSelector({
            menuCls: "paperSizeSelectorMenu",
            renderTo: this.paperSizeSelectorContainer,
            value: printParameters.paperSize,
            listItems: [
                {
                    text: messageResource.getMessage("report.chart_pdf_preview.paper_size.letter"),
                    value: PaperSize.LETTER
                },
                {
                    text: messageResource.getMessage("report.chart_pdf_preview.paper_size.a4"),
                    value: PaperSize.A4
                }
            ]
        });
        this.paperSizeSelector.on("change", this.changesCallback);

        if (printParameters.paperOrientation == PaperOrientation.PORTRAIT)
            this.portraitOrientationRadio.checked = true;
        else
            this.landscapeOrientationRadio.checked = true;

        this.showHeaderOnEachPageCheckbox.checked = printParameters.showHeaderOnEachPage;
        this.showLogoInHeaderCheckbox.checked = printParameters.showLogoInHeader;
    }

    subscribeToEvents() {
        var $store = $(this.getStore());
        var self = this;
        $store.on("printParametersForSaveChange", function() {
            self.update();
        });
        $store.on("printNumberOfPagesChange", function() {
            self.updateNumberOfPagesInformation();
        });
    }

    unsubscribeFromEvents() {
        $(this.getStore()).off("printParametersForSaveChange").off("printNumberOfPagesChange");
    }

    templateModel() {
        return {id: this.lightboxId}
    }

    messageKeys() {
        return {
            "pageSetupLabel": "report.chart_pdf_preview.page_setup",
            "paperSizeLabel": "report.chart_pdf_preview.paper_size",
            "orientationLabel": "report.chart_pdf_preview.orientation",
            "orientationPortraitLabel": "report.chart_pdf_preview.orientation.portrait",
            "orientationLandscapeLabel": "report.chart_pdf_preview.orientation.landscape",
            "showHeaderLabel": "report.chart_pdf_preview.show_header_each_page",
            "showLogoLabel": "report.chart_pdf_preview.show_logo",
            "pagesNumberLabel": "report.chart_pdf_preview.pages_number",
            "updatePreviewButtonLabel": "report.chart_pdf_preview.updatePreviewButton.caption",
            "loadingPreviewLabel": "report.chart_pdf_preview.loading_preview"
        };
    }

    getStore() {
        // Abstract
    }

    getCustomSettingsSectionContainer() {
        return this.find(".customSettingsSectionContainer");
    }

    initPaperSizeSelector() {
        this.paperSizeSelectorContainer = document.getElementById(this.lightboxId + "_paperSizeSelector");
    }

    initPaperOrientationRadio() {
        this.portraitOrientationRadio = document.getElementById(this.lightboxId + "_portrait");
        this.landscapeOrientationRadio = document.getElementById(this.lightboxId + "_landscape");
        var radioGroupName = this.lightboxId + "_pageOrientation";
        $("input[type=radio][name=" + radioGroupName + "]").off().change(this.changesCallback);
    }

    initHeaderCheckboxes() {
        this.showHeaderOnEachPageCheckbox = document.getElementById(this.lightboxId + "_headerOnEachPage");
        this.showHeaderOnEachPageCheckbox.onchange = this.changesCallback;
        this.showLogoInHeaderCheckbox = document.getElementById(this.lightboxId + "_logoInHeader");
        this.showLogoInHeaderCheckbox.onchange = this.changesCallback;
    }

    handleParameterChange() {
        if (!this.parametersChanged) {
            this.parametersChanged = true;
            this.enableUpdatePreviewButton();
        }

        this.triggerIntermediatePrintParametersChange(this.collectPrintParametersForGenerate());
    }

    _getPaperOrientationParameter() {
        return this.portraitOrientationRadio.checked ? PaperOrientation.PORTRAIT : PaperOrientation.LANDSCAPE;
    }

    _getPaperSizeParameter() {
        return this.paperSizeSelector.getSelectedItem().value;
    }

    collectPrintParametersForGenerate() {
        return {
            paperSize: this._getPaperSizeParameter(),
            paperOrientation: this._getPaperOrientationParameter(),
            showHeaderOnEachPage: this.showHeaderOnEachPageCheckbox.checked,
            showLogoInHeader: this.showLogoInHeaderCheckbox.checked
        };
    }

    collectPrintParametersForSave() {
        return {
            paperSize: this._getPaperSizeParameter(),
            showHeaderOnEachPage: this.showHeaderOnEachPageCheckbox.checked,
            showLogoInHeader: this.showLogoInHeaderCheckbox.checked,
            paperOrientation: this._getPaperOrientationParameter()
        };
    }

    disableUpdatePreviewButton() {
        this.updatePreviewBtnEnabled = false;
        this.updatePreviewButton.addClass("disabled");
    }

    enableUpdatePreviewButton() {
        this.updatePreviewBtnEnabled = true;
        this.updatePreviewButton.removeClass("disabled");
    }

    onUpdatePreviewButtonClicked() {
        if (this.updatePreviewBtnEnabled) {
            this.unsubscribeFromEvents();
            this.triggerPrintParametersForSaveChange(this.collectPrintParametersForSave());
            this.subscribeToEvents();

            this.triggerPrintParametersForGenerateChange(this.collectPrintParametersForGenerate());
        }
    }

    triggerIntermediatePrintParametersChange(newPrintParameters) {
        // Abstract
    }

    triggerPrintParametersForSaveChange(printParametersForSave) {
        // Abstract
    }

    triggerPrintParametersForGenerateChange(printParametersForGenerate) {
        // Empty by default
    }

    beforePreviewUpdate() {
        this.disableUpdatePreviewButton();
        this.parametersChanged = false;
    }

    updateNumberOfPagesInformation() {
        this.numberOfPagesContainer.text(this.getStore().getPrintNumberOfPages());
    }
}


// WEBPACK FOOTER //
// ./web/js/pdfSettingsPreview/PDFSettingsPreview.js